import { MODULE_KEYS, FEATURE_KEYS, TELEMETRY_IDS, I18N_KEYS, ROUTE_IDS, ICON_IDS, OPERATION_IDS, } from '../routes/ids.js';
const ORGANIZATION_TITLE = 'hub.admin.organization.title';
const ORGANIZATION_DESCRIPTION = 'hub.admin.organization.description';
const ACCESS_INSPECTOR_DESCRIPTION = 'admin.accessInspector.description';
/** Organization-scoped administration surfaces.
 *
 * P2 hardening: Added approval-policies, permission-bundles, retention-policies,
 * export-policies, security-settings, regulatory-profile, jurisdiction-settings,
 * and support-access cards with accurate PLANNED/PARTIAL implementation status.
 * Platform Root must not receive this hub — resolved by backend experience
 * descriptor scope check. Org Client receives no Admin surface (HIDDEN).
 */
export const ORGANIZATION_ADMIN_HUB = {
    id: 'hub.admin.organization',
    schemaVersion: 1,
    module: MODULE_KEYS.ADMIN,
    feature: FEATURE_KEYS.NAVIGATION,
    telemetryId: TELEMETRY_IDS.HUB_ADMIN,
    accessibilityLabelKey: I18N_KEYS.HUB_ADMIN_ACCESSIBILITY,
    privacyClassification: 'INTERNAL',
    auditPolicy: 'NONE',
    owner: 'platform',
    titleKey: ORGANIZATION_TITLE,
    descriptionKey: ORGANIZATION_DESCRIPTION,
    availability: 'AVAILABLE',
    operationId: OPERATION_IDS.ADMIN_HUB_ORGANIZATION,
    groups: [
        {
            id: 'organization-admin-core',
            schemaVersion: 1,
            module: MODULE_KEYS.ADMIN,
            feature: FEATURE_KEYS.NAVIGATION,
            telemetryId: TELEMETRY_IDS.HUB_ADMIN_CORE,
            accessibilityLabelKey: I18N_KEYS.HUB_ADMIN_CORE_ACCESSIBILITY,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: ORGANIZATION_TITLE,
            availability: 'AVAILABLE',
            cards: [
                {
                    id: 'card.organization.governance',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_ORGANIZATION_GOVERNANCE,
                    telemetryId: TELEMETRY_IDS.ADMIN_ORGANIZATION_GOVERNANCE,
                    accessibilityLabelKey: I18N_KEYS.CARD_ORGANIZATION_GOVERNANCE_ACCESSIBILITY,
                    privacyClassification: 'CONFIDENTIAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    routeId: ROUTE_IDS.ORGANIZATION_GOVERNANCE_WORKSPACE,
                    titleKey: I18N_KEYS.PAGE_ORGANIZATION_GOVERNANCE_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_ORGANIZATION_GOVERNANCE_DESCRIPTION,
                    iconKey: ICON_IDS.SECURITY,
                    availability: 'AVAILABLE',
                    wip: true,
                    operationId: OPERATION_IDS.ORGANIZATION_GOVERNANCE_WORKSPACE_READ,
                },
                {
                    id: 'card.organization.profile',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_ORGANIZATION,
                    accessibilityLabelKey: I18N_KEYS.CARD_ORGANIZATION_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-profile',
                    routeId: ROUTE_IDS.ORGANIZATION_PROFILE,
                    titleKey: I18N_KEYS.PAGE_ORGANIZATION_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_ORGANIZATION_DESCRIPTION,
                    iconKey: ICON_IDS.BUSINESS,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ORGANIZATION_PROFILE_READ,
                },
                {
                    id: 'card.organization.users',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_USERS,
                    accessibilityLabelKey: I18N_KEYS.CARD_USERS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-users',
                    routeId: ROUTE_IDS.ORGANIZATION_USERS_LIST,
                    titleKey: I18N_KEYS.PAGE_ORGANIZATION_USERS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_ORGANIZATION_USERS_DESCRIPTION,
                    iconKey: ICON_IDS.USERS,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ORGANIZATION_USERS_LIST,
                },
                {
                    id: 'card.organization.roles',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_ROLES,
                    accessibilityLabelKey: I18N_KEYS.CARD_ROLES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-roles',
                    routeId: ROUTE_IDS.ORGANIZATION_ROLES_LIST,
                    titleKey: I18N_KEYS.PAGE_ORGANIZATION_ROLES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_ORGANIZATION_ROLES_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK,
                    availability: 'AVAILABLE',
                    wip: true,
                    operationId: OPERATION_IDS.ORGANIZATION_ROLES_LIST,
                },
                {
                    id: 'card.organization.audit',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_AUDIT,
                    telemetryId: TELEMETRY_IDS.CARD_AUDIT,
                    accessibilityLabelKey: I18N_KEYS.CARD_AUDIT_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-audit',
                    routeId: ROUTE_IDS.ORGANIZATION_AUDIT_LIST,
                    titleKey: I18N_KEYS.PAGE_ORGANIZATION_AUDIT_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_ORGANIZATION_AUDIT_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    availability: 'AVAILABLE',
                    wip: true,
                    operationId: OPERATION_IDS.ORGANIZATION_AUDIT_LIST,
                },
                {
                    id: 'card.organization.accessInspector',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_ORGANIZATION_ACCESS_INSPECTOR,
                    telemetryId: TELEMETRY_IDS.ADMIN_ORGANIZATION_ACCESS_INSPECTOR,
                    accessibilityLabelKey: I18N_KEYS.PAGE_ORGANIZATION_ACCESS_INSPECTOR_TITLE,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-access-inspector',
                    routeId: ROUTE_IDS.ORGANIZATION_ACCESS_INSPECTOR,
                    titleKey: I18N_KEYS.PAGE_ORGANIZATION_ACCESS_INSPECTOR_TITLE,
                    descriptionKey: ACCESS_INSPECTOR_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK,
                    availability: 'AVAILABLE',
                    wip: true,
                    operationId: OPERATION_IDS.ORGANIZATION_ACCESS_INSPECTOR_READ,
                },
                {
                    id: 'card.organization.branches',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_ORGANIZATION_BRANCHES,
                    telemetryId: TELEMETRY_IDS.CARD_BRANCHES,
                    accessibilityLabelKey: I18N_KEYS.CARD_BRANCHES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-branches',
                    routeId: ROUTE_IDS.ORGANIZATION_BRANCHES_LIST,
                    titleKey: I18N_KEYS.PAGE_BRANCHES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_BRANCHES_DESCRIPTION,
                    iconKey: ICON_IDS.BUSINESS,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ORGANIZATION_BRANCHES_LIST,
                    wip: true,
                    // Hidden from all environments via HubResolverService runtime check.
                    // The field exists on HubCardDefinition but not on the type alias used here.
                    discoverable: false,
                },
                {
                    id: 'card.organization.moduleAssignments',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_ORGANIZATION_MODULES,
                    telemetryId: TELEMETRY_IDS.CARD_MODULE_ASSIGNMENTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_MODULE_ASSIGNMENTS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-module-activations',
                    routeId: ROUTE_IDS.ORGANIZATION_MODULES_LIST,
                    titleKey: I18N_KEYS.PAGE_MODULE_ASSIGNMENTS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_MODULE_ASSIGNMENTS_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK,
                    availability: 'AVAILABLE',
                    wip: true,
                    operationId: OPERATION_IDS.ORGANIZATION_MODULES_LIST_ASSIGNED,
                },
                {
                    id: 'card.organization.clients',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_CLIENTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_CLIENTS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-clients',
                    routeId: ROUTE_IDS.ORGANIZATION_CLIENTS_LIST,
                    titleKey: I18N_KEYS.PAGE_CLIENTS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_CLIENTS_DESCRIPTION,
                    iconKey: ICON_IDS.USERS,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ORGANIZATION_CLIENTS_LIST,
                },
                {
                    id: 'card.organization.clientAccounts',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_CLIENT_ACCOUNTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_CLIENT_ACCOUNTS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-client-accounts',
                    routeId: ROUTE_IDS.ORGANIZATION_CLIENT_ACCOUNTS_LIST,
                    titleKey: I18N_KEYS.PAGE_CLIENT_ACCOUNTS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_CLIENT_ACCOUNTS_DESCRIPTION,
                    iconKey: ICON_IDS.USERS,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ORGANIZATION_CLIENT_ACCOUNTS_LIST,
                },
                {
                    id: 'card.organization.portfolios',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_PORTFOLIOS,
                    accessibilityLabelKey: I18N_KEYS.CARD_PORTFOLIOS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-portfolios',
                    routeId: ROUTE_IDS.ORGANIZATION_PORTFOLIOS_LIST,
                    titleKey: I18N_KEYS.PAGE_PORTFOLIOS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PORTFOLIOS_DESCRIPTION,
                    iconKey: ICON_IDS.BUSINESS,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ORGANIZATION_PORTFOLIOS_LIST,
                },
                {
                    id: 'card.organization.openingCutover',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_OPENING_CUTOVER,
                    accessibilityLabelKey: I18N_KEYS.CARD_OPENING_CUTOVER_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'organization-opening-cutover',
                    routeId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_LIST,
                    titleKey: I18N_KEYS.PAGE_OPENING_CUTOVER_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_OPENING_CUTOVER_DESCRIPTION,
                    iconKey: ICON_IDS.IMPORT,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_GET,
                },
                {
                    id: 'card.organization.taxRules',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_TAX_RULES,
                    telemetryId: TELEMETRY_IDS.CARD_TAX_RULES,
                    accessibilityLabelKey: I18N_KEYS.CARD_TAX_RULES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'organization-tax-rules',
                    routeId: ROUTE_IDS.ADMIN_TAX_RULES_LIST,
                    titleKey: I18N_KEYS.PAGE_TAX_RULES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_TAX_RULES_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.TAX_RULE_LIST,
                },
                {
                    id: 'card.organization.feeRules',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_FEE_RULES,
                    telemetryId: TELEMETRY_IDS.CARD_FEE_RULES,
                    accessibilityLabelKey: I18N_KEYS.CARD_FEE_RULES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'organization-fee-rules',
                    routeId: ROUTE_IDS.ADMIN_FEE_RULES_LIST,
                    titleKey: I18N_KEYS.PAGE_FEE_RULES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_FEE_RULES_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    availability: 'AVAILABLE',
                    operationId: OPERATION_IDS.FEE_RULE_LIST,
                },
                {
                    id: 'card.organization.permissionAssignments',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.NAVIGATION,
                    telemetryId: TELEMETRY_IDS.CARD_PERMISSION_ASSIGNMENTS,
                    accessibilityLabelKey: I18N_KEYS.CARD_PERMISSION_ASSIGNMENTS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-permission-assignments',
                    routeId: ROUTE_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST,
                    titleKey: I18N_KEYS.PAGE_PERMISSION_ASSIGNMENTS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PERMISSION_ASSIGNMENTS_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_PERMISSION_ASSIGNMENTS_LIST,
                },
                // ── P2 hardening: missing org-admin capabilities ───────────────────
                {
                    id: 'card.organization.permissionBundles',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_PERMISSION_BUNDLES,
                    telemetryId: TELEMETRY_IDS.CARD_PERMISSION_BUNDLES,
                    accessibilityLabelKey: I18N_KEYS.CARD_PERMISSION_BUNDLES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-permission-bundles',
                    routeId: ROUTE_IDS.ORGANIZATION_PERMISSION_BUNDLES_LIST,
                    titleKey: I18N_KEYS.PAGE_PERMISSION_BUNDLES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_PERMISSION_BUNDLES_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_PERMISSION_BUNDLES_LIST,
                },
                {
                    id: 'card.organization.approvalPolicies',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_APPROVAL_POLICIES,
                    telemetryId: TELEMETRY_IDS.CARD_APPROVAL_POLICIES,
                    accessibilityLabelKey: I18N_KEYS.CARD_APPROVAL_POLICIES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-approval-policies',
                    routeId: ROUTE_IDS.ORGANIZATION_APPROVAL_POLICIES_LIST,
                    titleKey: I18N_KEYS.PAGE_APPROVAL_POLICIES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_APPROVAL_POLICIES_DESCRIPTION,
                    iconKey: ICON_IDS.TUNE,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_APPROVAL_POLICIES_LIST,
                },
                {
                    id: 'card.organization.supportAccess',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_SUPPORT_ACCESS,
                    telemetryId: TELEMETRY_IDS.CARD_SUPPORT_ACCESS,
                    accessibilityLabelKey: I18N_KEYS.CARD_SUPPORT_ACCESS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'organization-support-access',
                    routeId: ROUTE_IDS.ORGANIZATION_SUPPORT_ACCESS,
                    titleKey: I18N_KEYS.PAGE_SUPPORT_ACCESS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_SUPPORT_ACCESS_DESCRIPTION,
                    iconKey: ICON_IDS.SECURITY,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_SUPPORT_ACCESS_READ,
                },
                {
                    id: 'card.organization.retentionPolicies',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_RETENTION_POLICIES,
                    telemetryId: TELEMETRY_IDS.CARD_RETENTION_POLICIES,
                    accessibilityLabelKey: I18N_KEYS.CARD_RETENTION_POLICIES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-retention-policies',
                    routeId: ROUTE_IDS.ORGANIZATION_RETENTION_POLICIES,
                    titleKey: I18N_KEYS.PAGE_RETENTION_POLICIES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_RETENTION_POLICIES_DESCRIPTION,
                    iconKey: ICON_IDS.TUNE,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_RETENTION_POLICIES_READ,
                },
                {
                    id: 'card.organization.exportPolicies',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_EXPORT_POLICIES,
                    telemetryId: TELEMETRY_IDS.CARD_EXPORT_POLICIES,
                    accessibilityLabelKey: I18N_KEYS.CARD_EXPORT_POLICIES_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-export-policies',
                    routeId: ROUTE_IDS.ORGANIZATION_EXPORT_POLICIES,
                    titleKey: I18N_KEYS.PAGE_EXPORT_POLICIES_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_EXPORT_POLICIES_DESCRIPTION,
                    iconKey: ICON_IDS.EXPORT,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_EXPORT_POLICIES_READ,
                },
                {
                    id: 'card.organization.securitySettings',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_SECURITY_SETTINGS,
                    telemetryId: TELEMETRY_IDS.CARD_SECURITY_SETTINGS,
                    accessibilityLabelKey: I18N_KEYS.CARD_SECURITY_SETTINGS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'organization-security-settings',
                    routeId: ROUTE_IDS.ORGANIZATION_SECURITY_SETTINGS,
                    titleKey: I18N_KEYS.PAGE_SECURITY_SETTINGS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_SECURITY_SETTINGS_DESCRIPTION,
                    iconKey: ICON_IDS.LOCK,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_SECURITY_SETTINGS_READ,
                },
                {
                    id: 'card.organization.regulatoryProfile',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_REGULATORY_PROFILE,
                    telemetryId: TELEMETRY_IDS.CARD_REGULATORY_PROFILE,
                    accessibilityLabelKey: I18N_KEYS.CARD_REGULATORY_PROFILE_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-regulatory-profile',
                    routeId: ROUTE_IDS.ORGANIZATION_REGULATORY_PROFILE,
                    titleKey: I18N_KEYS.PAGE_REGULATORY_PROFILE_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_REGULATORY_PROFILE_DESCRIPTION,
                    iconKey: ICON_IDS.RECEIPT,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_REGULATORY_PROFILE_READ,
                },
                {
                    id: 'card.organization.jurisdictionSettings',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_JURISDICTION_SETTINGS,
                    telemetryId: TELEMETRY_IDS.CARD_JURISDICTION_SETTINGS,
                    accessibilityLabelKey: I18N_KEYS.CARD_JURISDICTION_SETTINGS_ACCESSIBILITY,
                    privacyClassification: 'INTERNAL',
                    auditPolicy: 'NONE',
                    owner: 'platform',
                    resourceId: 'organization-jurisdiction-settings',
                    routeId: ROUTE_IDS.ORGANIZATION_JURISDICTION_SETTINGS,
                    titleKey: I18N_KEYS.PAGE_JURISDICTION_SETTINGS_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_JURISDICTION_SETTINGS_DESCRIPTION,
                    iconKey: ICON_IDS.PERSON,
                    availability: 'PLANNED',
                    operationId: OPERATION_IDS.ORGANIZATION_JURISDICTION_SETTINGS_READ,
                },
            ],
        },
        {
            id: 'organization-admin-setup-history',
            schemaVersion: 1,
            module: MODULE_KEYS.ADMIN,
            feature: FEATURE_KEYS.NAVIGATION,
            telemetryId: TELEMETRY_IDS.HUB_ADMIN_SETUP_HISTORY,
            accessibilityLabelKey: I18N_KEYS.HUB_ADMIN_SETUP_HISTORY_ACCESSIBILITY,
            privacyClassification: 'INTERNAL',
            auditPolicy: 'NONE',
            owner: 'platform',
            titleKey: I18N_KEYS.HUB_ADMIN_SETUP_HISTORY_TITLE,
            availability: 'AVAILABLE',
            cards: [
                {
                    id: 'card.organization.openingCutoverHistory',
                    schemaVersion: 1,
                    module: MODULE_KEYS.ADMIN,
                    feature: FEATURE_KEYS.ADMIN_OPENING_CUTOVER,
                    telemetryId: TELEMETRY_IDS.CARD_OPENING_CUTOVER_HISTORY,
                    accessibilityLabelKey: I18N_KEYS.CARD_OPENING_CUTOVER_HISTORY_ACCESSIBILITY,
                    privacyClassification: 'CONFIDENTIAL',
                    auditPolicy: 'ALWAYS',
                    owner: 'platform',
                    resourceId: 'organization-opening-cutover-history',
                    routeId: ROUTE_IDS.ADMIN_OPENING_CUTOVER_HISTORY,
                    titleKey: I18N_KEYS.PAGE_OPENING_CUTOVER_HISTORY_TITLE,
                    descriptionKey: I18N_KEYS.PAGE_OPENING_CUTOVER_HISTORY_DESCRIPTION,
                    iconKey: ICON_IDS.HISTORY,
                    availability: 'HISTORICAL',
                    operationId: OPERATION_IDS.ACCOUNTING_OPENING_CUTOVER_GET,
                },
            ],
        },
    ],
};
